import { render, staticRenderFns } from "./RailForm.vue?vue&type=template&id=5b0f8eb6&scoped=true&"
import script from "./RailForm.vue?vue&type=script&lang=js&"
export * from "./RailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f8eb6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0f8eb6')) {
      api.createRecord('5b0f8eb6', component.options)
    } else {
      api.reload('5b0f8eb6', component.options)
    }
    module.hot.accept("./RailForm.vue?vue&type=template&id=5b0f8eb6&scoped=true&", function () {
      api.rerender('5b0f8eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/OfferItemForm/RailForm.vue"
export default component.exports